import { jsx as _jsx } from "react/jsx-runtime";
export const PauseSolidXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            fill: color,
            d: "M6 1.25a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V2A.75.75 0 0 1 3 1.25zM13 1.25a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75V2a.75.75 0 0 1 .75-.75z"
        })
    });

//# sourceMappingURL=pause-solid-xs.js.map